import React, { FunctionComponent } from "react";
import styles from "./css/Section2.module.css";
import { useSelector } from "react-redux";
import marianaAbout2 from "../../assets/mariana_pics/about2.png";
const Section2 = () => {
  const language = useSelector((state: any) => state.language.value);

  return (
    <div className={styles.frag} style={{ backgroundColor: "#F9F6E9" }}>
      <div className={styles.mainContainer}>
        <div className={styles.group}>
          <img src={marianaAbout2} alt="book" className={styles.mariana} />
          <div className={styles.photoText}>
            <span className={styles.text}>
              {language === "EN" && (
                <>
                  People come into our lives for a reason. Maybe it’s a word, a
                  glance, or a conversation that changes our direction. There
                  are people who, through their mere presence, light up a place
                  where there was once darkness. I have been blessed to meet
                  such people in moments when I felt lost. They helped me find
                  my path, believe in myself again, and discover my freedom.
                  Each of us needs a guide, a soul to inspire us and show us
                  that we can live differently — free from norms, fears, and the
                  limits we have imposed on ourselves. When I cried in the most
                  beautiful places in the world, in relationships that everyone
                  said were "like in the movies," my soul was actually longing
                  for freedom. The freedom to leave a relationship that seemed
                  perfect to others but did not nourish my soul.
                </>
              )}
              {language === "RO" && (
                <>
                  Oamenii apar în viața noastră cu un scop. Poate e un cuvânt, o
                  privire sau o discuție care ne schimbă direcția. Sunt oameni
                  care, prin simpla lor prezență, aprind o lumină acolo unde era
                  întuneric. Am fost binecuvântată să întâlnesc astfel de oameni
                  în momentele în care mă simțeam pierdută. Ei m-au ajutat să-mi
                  descopăr drumul, să cred din nou în mine și să-mi găsesc
                  libertatea. Fiecare dintre noi are nevoie de un ghid, de un
                  suflet care să ne inspire și să ne arate că putem trăi altfel
                  — liberi de norme, de frici și de limitele pe care tot noi ni
                  le-am impus. Când plângeam în cele mai frumoase locuri ale
                  lumii, în relații despre care toți spuneau că sunt «ca în
                  filme», sufletul meu tânjea, de fapt, după libertate.
                  Libertatea de a părăsi o relație care părea perfectă pentru
                  alții, dar care nu îmi hrănea sufletul.
                </>
              )}
            </span>
          </div>
        </div>
        <div className={styles.elementLeft}>
          <div className={styles.wrapper}>
            {language === "EN" && (
              <>
                <div className={styles.group2}>
                  <span className={styles.text2}>
                    “I don’t believe in coincidences,{" "}
                  </span>
                  <span className={styles.text3}>I believe in people!”</span>
                </div>
                <div className={styles.box}>
                  <span className={styles.text4}>“</span>
                  <span className={styles.text5}>
                    I don’t believe in coincidences,{" "}
                  </span>
                  <span className={styles.text6}>I believe in people! </span>
                  <span className={styles.text7}>e</span>
                </div>
              </>
            )}
            {language === "RO" && (
              <>
                <div className={styles.group2}>
                  <span className={styles.text2}>
                    “Eu nu cred în coincidențe,{" "}
                  </span>
                  <span className={styles.text3}>eu cred în oameni!”</span>
                </div>
                <div className={styles.box}>
                  <span className={styles.text4}>“</span>
                  <span className={styles.text5}>
                    Eu nu cred în coincidențe,{" "}
                  </span>
                  <span className={styles.text6}>eu cred în oameni! </span>
                  <span className={styles.text7}>e</span>
                </div>
              </>
            )}
          </div>

          <div className={styles.text}>
            {language === "EN" && (
              <>
                <span className={styles.oameniiAparViata}>
                  People come into our lives for a reason. Maybe it’s a word, a
                  glance, or a conversation that changes our direction. There
                  are people who, through their mere presence, light up a place
                  where there was once darkness.
                  <br />I have been blessed to meet such people in moments when
                  I felt lost. They helped me find my path, believe in myself
                  again, and discover my freedom.
                </span>
                <span className={styles.aziVreauFiu}>
                  Today, I want to be that person for you.
                </span>
                <span className={styles.fiecareNoiGhid}>
                  Each of us needs a guide, a soul to inspire us and show us
                  that we can live differently — free from norms, fears, and the
                  limits we have imposed on ourselves.
                </span>
              </>
            )}
            {language === "RO" && (
              <>
                <span className={styles.oameniiAparViata}>
                  Oamenii apar în viața noastră cu un scop. Poate e un cuvânt, o
                  privire sau o discuție care ne schimbă direcția. Sunt oameni
                  care, prin simpla lor prezență, aprind o lumină acolo unde era
                  întuneric.
                  <br />
                  Am fost binecuvântată să întâlnesc astfel de oameni în
                  momentele în care mă simțeam pierdută. Ei m-au ajutat să-mi
                  descopăr drumul, să cred din nou în mine și să-mi găsesc
                  libertatea.
                </span>
                <span className={styles.aziVreauFiu}>
                  Azi, vreau să fiu acel om pentru tine.
                </span>
                <span className={styles.fiecareNoiGhid}>
                  Fiecare dintre noi are nevoie de un ghid, de un suflet care să
                  ne inspire și să ne arate că putem trăi altfel — liberi de
                  norme, de frici și de limitele pe care tot noi ni le-am impus.
                </span>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section2;
